<template>
<span>

    <v-toolbar flat color="white">
        <v-toolbar-title class="lime--text lighten-1">Gerenciar Departamentos</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <template>
            <v-btn color="grey darken-2" dark class="mb-1" @click.prevent="atualizarDados">
                <v-icon dark class="mdi mdi-sync"></v-icon>Atualizar
            </v-btn>
            <v-btn color="success" dark class="mb-1 ml-2" :to="{name: 'department.add'}">
                <v-icon class="mdi mdi-plus"></v-icon>
                Adicionar Novo Departamento
            </v-btn>
        </template>
    </v-toolbar>

    <v-card>
        <v-card-title>
            <v-text-field v-model="search" append-icon="search" label="Localizar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="loadDepartments" :search="search" :rowsPerPageItems="rowsPerPageItems">

            <template v-slot:[`item.comp_fantasia`]="{ item }">
                <td width="20%">{{ item.empresa.comp_fantasia }}</td>
            </template>

            <template v-slot:[`item.dept_status`]="{ item }">
                <td>
                    <v-switch color="lime" v-model="item.dept_status" @change="onChangeEventHandlertSatus(item.dept_id, $event)" class="my-switch"></v-switch>
                </td>
            </template>

            <template v-slot:[`item.dept_show_link_contato`]="{ item }">
                <td>
                    <v-switch color="lime" v-model="item.dept_show_link_contato" @change="onChangeEventHandlerShowLinkContato(item.dept_id, $event)" class="my-switch"></v-switch>
                </td>
            </template>

            <template v-slot:[`item.acoes`]="{ item }">
                <v-tooltip top color="blue white--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="blue lighten-1" @click.prevent="editDepartment(item)" v-on="on">
                            <v-icon dark>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>Editar</span>
                </v-tooltip>

                <v-tooltip top color="red white--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="red lighten-1" @click.prevent="deleteDepartment(item)" v-on="on">
                            <v-icon dark class="mdi mdi-delete"></v-icon>
                        </v-btn>
                    </template>
                    <span>Excluir</span>
                </v-tooltip>
            </template>

            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    Voce procurou por "{{ search }}" nenhum item localizado.
                </v-alert>
            </template>

        </v-data-table>
    </v-card>

</span>
</template>

<script>
import {
    URL_BASE
} from '../../../config/configs'

export default {
    created() {
        this.$store.dispatch('loadDepartments');
    },
    computed: {
        loadDepartments() {
            if (this.$store.state.departments.items.data == null)
                return []

            return this.$store.state.departments.items.data;
        }
    },
    name: "DepartmentComponent",
    data() {
        return {
            search: '',
            rowsPerPageItems: [10, 20, 30, {
                "text": "$vuetify.dataIterator.rowsPerPageAll",
                "10": -1
            }],
            headers: [{
                    sortable: false,
                    text: 'Nome',
                    value: 'dept_nome'
                },
                {
                    sortable: false,
                    text: 'Email',
                    value: 'dept_email'
                },
                {
                    sortable: false,
                    text: 'Empresa',
                    value: 'comp_fantasia'
                },
                {
                    sortable: false,
                    text: 'Status',
                    value: 'dept_status'
                },
                {
                    sortable: false,
                    text: 'Show Setor',
                    value: 'dept_show_link_contato'
                },
                {
                    text: 'Ações',
                    align: 'center',
                    sortable: false,
                    value: 'acoes'
                }
            ],
            department: [],
            base_url: URL_BASE
        }
    },
    methods: {
        atualizarDados() {
            this.$store.dispatch('loadDepartments');
        },
        editDepartment(item) {
            this.$router.push({
                name: 'department.edit',
                params: {
                    dept_id: item.dept_id
                }
            });
        },
        deleteDepartment(item, index) {
            this.$swal({
                title: 'Você tem certeza?',
                text: "Todos os funcionários desse departamento serão excluídos",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#D32F2F',
                cancelButtonColor: '#1976D2',
                confirmButtonText: 'Sim, Exclua!'
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch('destroyDepartment', item.dept_id)
                        .then(response => {
                            if (response) {
                                this.$swal({
                                    position: "center",
                                    icon: "success",
                                    title: 'Sucesso',
                                    text: 'Dados excluídos com sucesso',
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                                this.$store.state.departments.items.data.splice(index, 1);
                            } else {
                                this.$swal({
                                    position: "center",
                                    icon: "error",
                                    title: 'Opssss!',
                                    text: 'Erro ao excluir dados',
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                            }
                        })
                        .catch(error => {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: 'Opssss!',
                                text: 'Algo errado aconteceu!',
                                showConfirmButton: true,
                                timer: 6000
                            });
                        })
                }
            })

        },
        onChangeEventHandlertSatus(dept_id, value) {
            this.$store.dispatch('updateDepartmentStatus', {
                    dept_id: dept_id,
                    dept_status: value
                })
                .then(() => {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: 'Sucesso',
                        text: 'Status atualizado com sucesso',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: 'Opssss!',
                        text: 'Erro ao atualizar status',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
        },
        onChangeEventHandlerShowLinkContato(dept_id, value) {
            this.$store.dispatch('updateDepartmentShowLinkContato', {
                    dept_id: dept_id,
                    dept_show_link_contato: value
                })
                .then(() => {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: 'Sucesso',
                        text: 'Status atualizado com sucesso',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: 'Opssss!',
                        text: 'Erro ao atualizar status',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
        },
    },
};
</script>

<style scoped>

</style>
